<app-shimmer-loader *ngIf="loading"
                    [count]="1"
                    [theme]="{'height': '5rem'}"
                    appearance="line"
                    class="line"></app-shimmer-loader>
<div *ngIf="!loading"
     class="toggle-wrapper w-full">
  <div class="flex h-full justify-start items-center lg:overflow-y-auto overflow-y-scroll week-list-wrapper">
    <div (click)="toggle(week)"
         *ngFor="let week of weekList;let index=index"
         [class.disabled]="isFuture(week)"
         [class.selected]="week.date == selectedDate"
         class="week-wrapper flex flex-col
        items-center
        justify-center
        min-w-[50%]
        max-w-[50%]
        sm:min-w-[14.28%]
        sm:max-w-[14.28%]
        h-full">
      <div class="w-full flex justify-center items-center">
                <span [ngClass]="week?.completed ? 'day-label-completed':'day-label'">
                    {{ week?.date | date : 'EEE' }}
                </span>
        <span *ngIf="week?.eJournalRLExists || week?.eJournalPAExists || week?.eJournalSTExists"
              class="check-icon-wrapper">
                    <app-icon class="check-icon"
                              svgIcon="check-circle"></app-icon>
                </span>
      </div>
      <div>
                <span *ngIf="week?.sessionNumber"
                      class="session">
                    {{ 'S' + week?.sessionNumber }}
                </span>
        <span class="date-label">
                    {{ week?.date | date:'MMM dd' }}
                </span>
      </div>
    </div>
  </div>
</div>
